import React from 'react';
import { AlertCircle, Clock, CheckCircle, XCircle, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

const AFAStatusBanner = ({ status, rejectionReason }) => {
  const navigate = useNavigate();

  // Don't show banner if approved (they have access)
  if (status === 'APPROVED' || !status) {
    return null;
  }

  const bannerConfig = {
    DRAFT: {
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      iconColor: 'text-blue-600',
      textColor: 'text-blue-900',
      icon: AlertCircle,
      title: 'Fullfør AFA-profilen din',
      description: 'Du må fullføre og sende inn profilen for å få tilgang til Advokat for alle-markedet.',
      actionText: 'Fullfør profil',
      actionPath: '/lexy/afa/profile'
    },
    SUBMITTED: {
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      iconColor: 'text-yellow-600',
      textColor: 'text-yellow-900',
      icon: Clock,
      title: 'Profilen din er under vurdering',
      description: 'Vi gjennomgår profilen din. Du vil få beskjed når den er godkjent. Dette tar normalt 1-2 virkedager.',
      actionText: 'Se profil',
      actionPath: '/lexy/afa/profile'
    },
    REJECTED: {
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      iconColor: 'text-red-600',
      textColor: 'text-red-900',
      icon: XCircle,
      title: 'Profilen din trenger endringer',
      description: rejectionReason || 'Vennligst gjennomgå og oppdater profilen din basert på tilbakemeldingen.',
      actionText: 'Rediger profil',
      actionPath: '/lexy/afa/profile'
    }
  };

  const config = bannerConfig[status];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <div className={`${config.bgColor} border ${config.borderColor} rounded-xl p-4 mb-6 shadow-sm`}>
      <div className="flex items-start gap-4">
        <div className={`${config.iconColor} mt-0.5`}>
          <Icon className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className={`text-sm font-semibold ${config.textColor} mb-1`}>
            {config.title}
          </h3>
          <p className={`text-sm ${config.textColor} opacity-90 mb-3`}>
            {config.description}
          </p>
          <Button
            onClick={() => navigate(config.actionPath)}
            size="sm"
            className="bg-white border border-gray-300 text-gray-900 hover:bg-gray-50 text-xs shadow-sm"
          >
            {config.actionText}
            <ChevronRight className="w-3 h-3 ml-1" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AFAStatusBanner;
